import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { onForbidden } from '../services/forbiddenEvents';

/**
 * Notifica globale delle negazioni di autorizzazione.
 *
 * Montata una volta sola in App: i componenti non la conoscono e non vanno modificati.
 * Il messaggio non dice quale ruolo servirebbe — la stessa scelta fatta lato backend in
 * GlobalExceptionHandler.handleAccessDenied.
 */
const ForbiddenNotice = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => onForbidden(() => setOpen(true)), []);

  return (
    <Snackbar
      open={open}
      autoHideDuration={8000}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert severity="warning" variant="filled" onClose={() => setOpen(false)}>
        Non hai i permessi per questa operazione. Se ritieni si tratti di un errore,
        contatta un amministratore.
      </Alert>
    </Snackbar>
  );
};

export default ForbiddenNotice;
